/**
 * Vibrations tactiles via navigator.vibrate.
 * Respecte prefers-reduced-motion (silence si réduit).
 */

const reducedMotion = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

const v = (pattern: number | number[]): void => {
  if (typeof navigator === 'undefined' || !navigator.vibrate) return;
  if (reducedMotion()) return;
  try { navigator.vibrate(pattern); } catch { /* noop */ }
};

/** Tap léger — feedback de validation (cocher série, valider repas) */
export const hapticTap = () => v(15);
/** Pulse moyen — fin de repos, transition d'étape */
export const hapticPulse = () => v(40);
/** Double pulse — fin de séance / succès important */
export const hapticSuccess = () => v([30, 60, 30]);
/** Pattern fort — fin de round boxe, alerte */
export const hapticAlert = () => v([60, 80, 60]);
